import { type LayerKindName, layersWithoutTimeRounding } from "@/layers/utility/createLayerObject";
import { roundToNearestFiveMinutes } from "@/time/roundToNearstFiveMinutes";
import type { DateTime } from "luxon";

export function roundToNearestCacheableTime(dateTime: DateTime, layerKind: LayerKindName): DateTime {
  if (layersWithoutTimeRounding.includes(layerKind)) {
    return dateTime;
  }
  return roundToNearestFiveMinutes(dateTime);
}
